// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fs-wrapper {
  border: solid 1px #dedede;
  border-radius: 3px;
  flex-direction: column;
  display: flex;
  resize: vertical;
  overflow: hidden;
  min-height: 10em;
}
.fs-wrapper > button {
  min-width: 24px;
  min-height: 24px;
  margin: 2px;
  align-self: end;
}
.fs-wrapper:hover {
  border: solid 1px #40a9ff;
}
.fs-wrapper:hover:active,
.fs-wrapper:focus {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.2);
}
.fs-wrapper.fullscreen {
  resize: none;
  background: white;
  z-index: 999;
  position: fixed;
}
`, "",{"version":3,"sources":["webpack://./src/Component/FullscreenWrapper/FullscreenWrapper.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AACF;AARA;EAUI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AACJ;AAEE;EACE,yBAAA;AAAJ;AAGE;;EAEE,6CAAA;AADJ;AAIE;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAFJ","sourcesContent":[".fs-wrapper {\n  border: solid 1px #dedede;\n  border-radius: 3px;\n  flex-direction: column;\n  display: flex;\n  resize: vertical;\n  overflow: hidden;\n  min-height: 10em;\n\n  >button {\n    min-width: 24px;\n    min-height: 24px;\n    margin: 2px;\n    align-self: end;\n  }\n\n  &:hover {\n    border: solid 1px #40a9ff;\n  }\n\n  &:hover:active,\n  &:focus {\n    box-shadow: 0 0 0 3px rgb(24 144 255 / 20%);\n  }\n\n  &.fullscreen {\n    resize: none;\n    background: white;\n    z-index: 999;\n    position: fixed;\n  }\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
